/** Time wording for home pages: "Recent changes" and "Needs attention". Server times without a zone are UTC. */

function parse(iso: string): Date {
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`);
}

/** "3:35 PM" today, "Nov 2, 3:35 PM" this year, else the date. */
export function whenText(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return '';
  const d = parse(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  if (d.toDateString() === now.toDateString()) return time;
  if (d.getFullYear() === now.getFullYear()) return `${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}, ${time}`;
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

/** "5 minutes", "3 hours", "2 days": how long ago. Null when unknown or in the future. */
export function ageText(iso: string | null | undefined, now: Date = new Date()): string | null {
  if (!iso) return null;
  const ms = now.getTime() - parse(iso).getTime();
  if (Number.isNaN(ms) || ms < 0) return null;
  const mins = Math.round(ms / 60000);
  if (mins < 60) return `${Math.max(1, mins)} minute${mins <= 1 ? '' : 's'}`;
  const hours = Math.round(mins / 60);
  if (hours < 48) return `${hours} hour${hours === 1 ? '' : 's'}`;
  return `${Math.round(hours / 24)} days`;
}

/** The oldest of some timestamps (ISO strings sort by time when they share a format). */
export function oldest(isos: ReadonlyArray<string | null | undefined>): string | null {
  let best: { iso: string; t: number } | null = null;
  for (const iso of isos) {
    if (!iso) continue;
    const t = parse(iso).getTime();
    if (Number.isNaN(t)) continue;
    if (!best || t < best.t) best = { iso, t };
  }
  return best?.iso ?? null;
}
